import { render, staticRenderFns } from "./ProductParagraph.vue?vue&type=template&id=29a75d77&scoped=true&"
import script from "./ProductParagraph.vue?vue&type=script&lang=js&"
export * from "./ProductParagraph.vue?vue&type=script&lang=js&"
import style0 from "./ProductParagraph.vue?vue&type=style&index=0&id=29a75d77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a75d77",
  null
  
)

export default component.exports